'use strict';

/*------------------------------------*\
 * JS Main entry file
 \*------------------------------------*/
import './config';

// Import utilities.
import { html } from '@utilities/dom-elements';
import moduleInit from '@utilities/module-init';
import '@utilities/in-view';
import AOS from 'AOS';

// Import Singletons
import '@utilities/detect-touch';
import video from '@utilities/video';
import image from '@utilities/image';
import fillCanvas from '@utilities/canvas';
import fillCanvasBG from '@utilities/bg_canvas';
import colorswap from '@utilities/colorswap';
import isTabbing from '@utilities/is-tabbing';

// Import components
import motions from './components/motions';
import tabs from './components/tabs';
import navigation from './components/navigation';
import search from './components/search';

window.addEventListener('load', function() { AOS.init({
    // duration: 200, // values from 0 to 3000, with step 50ms
    // delay: 500,
    // easing: 'ease-in-out-quad', // default easing for AOS animations
    once: true,
    // startEvent: 'load',
    // mirror: false, // whether elements should animate out while scrolling past them
    offset: 0
}); });

setInterval(() => {
    AOS.refresh();
  }, 200);

navigation();

let trailertrigger = document.querySelector('[js-hook-playtrailer]');

const loadCheck = () => {
    const pathname = window.location.pathname

    if (document.readyState === 'complete') {
        html.classList.add('page--is-loaded');

        if (trailertrigger !== null) {

            const iframe = document.querySelector('iframe');
            const player = new Vimeo.Player(iframe);

            trailertrigger.onclick = function () {
                document.querySelector('.trailer-container').classList.add('trailer-is-active');
                player.play();
            }
        }

        if (pathname === '/programme2019') {
            isTabbing();
            motions();
            tabs();
            search();
        }

        document.removeEventListener('readystatechange', loadCheck);
    }
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Color Swap

colorswap();

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Theme Slider

if (document.querySelector('[js-hook-slidertitle]') !== null) {
    document.querySelectorAll('[js-hook-categoryslider]').forEach((slider) => {
        let sliderTitle = slider.querySelector('[js-hook-slidertitle]');
        slider.addEventListener("scroll", function(){
            let sl = slider.scrollLeft;
            if(sl > 10){
                sliderTitle.classList.add('slider-active');
                // console.log(sl);
            } else {
                sliderTitle.classList.remove('slider-active');
            }
        });
    });
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Click Gallery

if (document.querySelector('[js-hook-gallery]') !== null) {
    document.querySelectorAll('[js-hook-gallery]').forEach((e) => {
        let items = e.children;
        let galleryIndex = 0;
        let galleryTime;

        const galleryChange = () => {
            items[galleryIndex].classList.remove('gallery-item_visible');
            galleryIndex == items.length - 1 ? galleryIndex = 0 : galleryIndex++;
            items[galleryIndex].classList.add('gallery-item_visible');
        }

        const gallerySetTimer = () => {
            galleryTime = setInterval(() => { galleryChange(); }, 2000);
        }
        gallerySetTimer();

    })
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Click Gallery theme

if (document.querySelector('[js-hook-gallery-theme]') !== null) {
    const caption_theme = document.querySelector('[js-hook-gallery-theme-caption]');
    let galleryThemeIndex = 0;
    let galleryThemeTime;
    caption_theme.innerHTML = document.querySelectorAll('.themes-gallery-item')[galleryThemeIndex].dataset.title;

    const galleryThemeChange = (clickOrTimer) => {

        if (!clickOrTimer){
            clearInterval(galleryThemeTime);
            galleryThemeSetTimer();
        }
        let galleryThemeItems = document.querySelectorAll('.themes-gallery-item');
        galleryThemeItems[galleryThemeIndex].classList.remove('themes-gallery-item_visible');
        galleryThemeIndex == galleryThemeItems.length - 1 ? galleryThemeIndex = 0 : galleryThemeIndex++;
        galleryThemeItems[galleryThemeIndex].classList.add('themes-gallery-item_visible');
        caption_theme.innerHTML = galleryThemeItems[galleryThemeIndex].dataset.title;
    }

    const galleryThemeSetTimer = () => {
        galleryThemeTime = setInterval(() => {
            galleryThemeChange('front', false);
        }, 4000);
    }
    galleryThemeSetTimer();
    
}


// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Designers page search

if(document.querySelector('[js-hook-search]') !== null) {

    let typingTimer;
    let typeInterval = 500; // Half a second
    let searchInput = document.querySelector('[js-hook-search]');

    searchInput.addEventListener('keyup', () => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(searchDesigners(), typeInterval);
    });
}

function searchDesigners(){
    let search_query = document.querySelector('[js-hook-search]').value;
    const empty_placeholder = document.querySelector('.empty-placeholder');
    if(search_query.length >=2){
        empty_placeholder.classList.remove('active');
        let names = document.querySelectorAll('[js-hook-designer]');
        let search_query = document.querySelector('[js-hook-search]').value;
        for (var i = 0; i < names.length; i++) {
            if(names[i].innerText.toLowerCase()
                .includes(search_query.toLowerCase())) {
                names[i].classList.remove("is-hidden");
            } else {
                names[i].classList.add("is-hidden");
            }
        }
        if (document.querySelectorAll('.is-hidden').length == names.length) {
            empty_placeholder.classList.add('active');
            empty_placeholder.innerHTML = '';
            empty_placeholder.append(`No result for "${search_query}"`);
        }
    } else {
        let names = document.querySelectorAll('[js-hook-designer]');
        for (var j = 0; j < names.length; j++) {
            names[j].classList.remove("is-hidden");
        }
    }
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Draggable carousels

if(document.querySelector('[js-hook-grabme]') !== null) {

    const slider = document.querySelector('[js-hook-grabme]');
    let slides = slider.children;

    let isDown = false;
    let isMoving = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        isMoving = false;
        slider.classList.add('active');
        startX = e.pageX;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', (e) => {
        e.preventDefault();
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {

        if(!isDown) return;
        isMoving = true;
        e.preventDefault();
        const x = e.pageX;

        const walk = (x-startX); //scroll-fast
        slider.scrollLeft = scrollLeft-walk;
    });

    for(let i = 0; i < slides.length; i++){
        slides[i].addEventListener("click", function(e){
            if(isMoving){
                e.preventDefault();
            }
        });
    }
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Draggable sliders

if(document.querySelector('[js-hook-list-switch]') !== null) {
    let items = document.querySelector('[js-hook-list-switch]').children;
    items[3].addEventListener('click', (e) => {
        [items[1], items[2]].forEach((e) => {
            e.classList.toggle('hidden');
        })
    })
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Draggable sliders

if(document.querySelector('[js-hook-categoryslider]') !== null) {

    let sliders = document.querySelectorAll('[js-hook-categoryslider]');
    sliders.forEach(function(slider){

        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });


        slider.addEventListener('mouseleave', () => {
            isDown = false;
        });


        slider.addEventListener('mouseup', () => {
            isDown = false;
        });


        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2.5; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
    });
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// ???

if (document.querySelector('[js-hook-show-participants]') !== null) {
    let showMoreButton = document.querySelector('[js-hook-show-participants]');
    let participantList = document.querySelector('[js-hook-participants-list]');

    showMoreButton.onclick = function () {
        if(participantList.classList.contains("pp--short")){
            participantList.classList.remove("pp--short");
            participantList.classList.add("pp--longer");
        } else {
            participantList.classList.add("pp--short");
            participantList.classList.remove("pp--longer");
        }
    }
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// DEMO Canvas

if (document.getElementById('canvas-container') !== null) {
    if (document.querySelector('[js-hook-script]').getAttribute('data-bg') == "canvas_bg") {
        fillCanvasBG();
    } else {
        fillCanvas();
    }
} else {
    moduleInit('[js-hook-video]', video);
    moduleInit('[js-hook-image]', image);
}

document.addEventListener('readystatechange', loadCheck);

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Themes carousel home page

if (document.querySelectorAll('.carousel-card').length > 0) {
    document.querySelectorAll('.carousel-card').forEach((item) => {
        item.addEventListener("mouseenter", function(){
            item.classList.add('card-hovering');
        });
        item.addEventListener("mouseleave", function(){
            item.classList.remove('card-hovering');
        });
    } )

    // Center carousel
    const w = window.innerWidth;
    const c = document.querySelector('.carousel-wrapper');
    const cw = c.getBoundingClientRect()['width'];
    let m = Math.round(cw - w) / 2 + 20;
    document.querySelector('.carousel').scrollLeft = m;
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————
// Info Accordion

if (document.querySelectorAll('.accordion-wrapper').length > 0) {
    const closeAll = () => {
        document.querySelectorAll('.accordion-wrapper').forEach((item) => {
            if (item.classList.contains('open')) {
                item.classList.remove('open');
                item.children[0].classList.remove('active');
                item.children[1].style.maxHeight = null;
            }
        })
    }
    document.querySelectorAll('.accordion-wrapper').forEach((item) => {
        item.addEventListener("click", function() {
            if (item.classList.contains('open')) {
                closeAll();
            } else {
                closeAll();
                item.classList.add('open');
                let b = item.children[0];
                let a = item.children[1];
                b.classList.add('active');

                if (a.style.maxHeight) {
                    a.style.maxHeight = null;
                } else {
                    a.style.maxHeight = a.scrollHeight + "px";
                }
            }
        });
    })
}

// ——————————————————————————————————————————————————————————————————————————————————————————————————————————————


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/javascript/main.js